import ClientsPageCaseStudies from "src/components/ClientsPage/ClientsPageCaseStudies";
import ColoredHeader from "@/components/Shared/ColoredHeader";
import CompanySlider_v2 from "@/components/Shared/CompanySlider_v2";
import FaqsSection from "@/components/Shared/FaqsSection";
import OurService from "@/components/Shared/OurService";
import SubmitForm from "@/components/Shared/SubmitForm";
import {
  ARROW_STYLES,
  CUSTOM_STYLES,
  SIGN,
  TITLE_STYLES,
} from "@/constants/clients";
import Collection from "@sourceflow-uk/sourceflow-sdk/collection";
import SEO from "@/components/SEO";
import localizePath from "@/functions/localizePath";
import back from "@/assets/clients/Rectangle 50@2x.png";
import bannerBottomAsset from "@/assets/clients/background-part-bottom.png";
import bannerAsset from "@/assets/clients/background-part.png";
import leftCornerIcon from "@/assets/clients/left-corner-icon.png";

export default function ClientsPage({ locale = "en", case_studies, faqs }) {
  return (
    <>
      <SEO
        path={localizePath("/clients", locale)}
        title="Clients | Lawrence Harvey"
        description="Finding you the best talent in tech"
      />
      <main className="bg-gradientLightBlue pt-[120px] h-full pb-24 sm:pb-[145px] relative clients-page">
        <ColoredHeader
          textBtn="Submit vacancies"
          link={localizePath("/vacancies", locale)}
          backgroundImage={back}
          text="Finding you the best talent in tech."
          path="clients"
        />
        <div className="absolute top-0 left-0 sm:w-[75%] lg:w-full">
          <img src={bannerAsset ?? ""} alt="top corner banner" />
        </div>
        <CompanySlider_v2
          isFooterExists={false}
          path="clients.company_slide"
          learnMore=""
          title="As good as the company we keep"
          cta_button_title_1="Learn more about us"
          description="We work with and value the big players in the tech markets, as much as the new up-and-comers. Whichever is the best fit for you, we’ll get it right."
        />
        <OurService
          background="bg-jacarta"
          learnMoreBgColor="gradientBlue"
          path="clients"
        />
        <img
          src={bannerBottomAsset ?? ""}
          alt="background-part-bottom"
          className="absolute right-0 bottom-[-134px] right-corner-img"
        />
      </main>
      <ClientsPageCaseStudies items={case_studies} />
      <FaqsSection
        customClass="clients-page"
        pathPrefix="clients_page"
        arrowStyles={ARROW_STYLES}
        blogsProps={{
          title: "Advice, insights and more from our expert teams.",
          styles: {
            txt: "text-white",
            active: "white",
            inactive: "purple",
            arrow: "[&>path]:fill-purple [&>path]:stroke-purple",
          },
        }}
        readToApplyBg="bg-blue mt-5"
        readyToApplyLink={localizePath("/vacancies", locale)}
        bgColor="bg-purple"
        titleStyles={TITLE_STYLES}
        sign={SIGN}
        customStyles={CUSTOM_STYLES}
        faqs={faqs.map(({question, question_de, answer, answer_de}) => ({
          ...(locale == "de" ? {question: question_de} : {question: question}),
          ...(locale == "de" ? {answer: answer_de } : {answer: answer})
        }))}
      />
      <div className="relative bg-purple z-[100]">
        <SubmitForm />
        <img
          className="absolute left-0 bottom-[-270px] sm:bottom-[-150px]"
          src={leftCornerIcon ?? ""}
          alt="left corner icon"
        />
      </div>
    </>
  );
}

export async function getStaticProps() {
  const faqs = (await Collection("clients_faq")).getItems();
  const case_studies = (await Collection("case_studies")).getItems();

  return { props: { case_studies, faqs } };
}
